"use client";

import type { ComponentType, ReactNode } from "react";
import type { SelectionIndicatorStyle } from "./form-types";

import { cn } from "@homeinstead/ui";
import { SelectedCheckmark } from "./SelectedCheckmark";

type SelectionIndicatorConfig = {
  Indicator: ComponentType;
  slotClass: string;
};

const SELECTION_INDICATORS: Record<
  Exclude<SelectionIndicatorStyle, "none">,
  SelectionIndicatorConfig
> = {
  checkmark: {
    Indicator: SelectedCheckmark,
    slotClass: "w-6",
  },
};

function SelectionIndicatorSlot({
  children,
  gapClass,
  isSelected,
  style,
}: {
  children: ReactNode;
  gapClass: string;
  isSelected: boolean;
  style: SelectionIndicatorStyle | null | undefined;
}) {
  const configuration =
    style && style !== "none"
      ? SELECTION_INDICATORS[style as Exclude<SelectionIndicatorStyle, "none">]
      : undefined;

  if (!configuration) {
    return children;
  }

  const { Indicator, slotClass } = configuration;

  return (
    <div className={cn("flex items-center", gapClass)}>
      <div className="min-w-0 flex-1">{children}</div>
      <div className={cn("shrink-0", slotClass)}>
        {isSelected ? <Indicator /> : null}
      </div>
    </div>
  );
}

export { SELECTION_INDICATORS, SelectionIndicatorSlot };
